export const newsListPath = "/news-editor"

// the app treats the first path segment as dealershipId, so news paths have to be detected explicitly
export const isNewsPath = (pathname: string): boolean =>
	pathname === newsListPath || pathname.startsWith(`${newsListPath}/`)

export const newsNewPath = `${newsListPath}/new`

export const getNewsEditPath = (newsItemId: string): string => `${newsListPath}/${encodeURIComponent(newsItemId)}`
